<template>
  <div class="popup-form">
    <div
      class="content-form-popup"
    >
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopup">
          <img class="nav-link-icon filter-primary" src="@/images/modal-close.svg" alt=""/>
        </div>
        <div class="blackcolor pop-800">Nastavenie brokera</div>
        <button class="w-button saveformBtn" v-if="!loading" @click="saveStaffProfile">Uložiť</button>

        <v-progress-circular
          class="loading-spinner small transparent"
          indeterminate
          v-else
        ></v-progress-circular>
      </div>

      <div v-if="staffProfile" class="popup-block flex-column broker-profile-card">
        <div class="broker-profile-card-header">
          <span class="broker-profile-label">Lokalita</span>
          <button class="broker-profile-link" type="button" @click="openBrokerLocalityServed">Editovať</button>
        </div>
        <div class="broker-districts">
          {{ districtNames || "Nie je nastavená žiadna lokalita" }}
        </div>
      </div>

      <button
        v-if="staffProfile"
        class="popup-block broker-pooling-toggle"
        :class="{ active: staffProfile.is_pooled }"
        type="button"
        @click="togglePooling"
      >
        <span class="toggle-track">
          <span class="toggle-thumb"></span>
        </span>
        <span>
          Prideľovanie aktívne
          <small>{{ staffProfile.is_pooled ? "Finančník prijíma automaticky prideľované leady." : "Finančník je mimo automatického prideľovania." }}</small>
        </span>
      </button>
      <div v-if="error" class="error-text">{{ error }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrokerStaffProfilePopUp",
  props: {
    payload: Object,
    metaData: Object,
  },
  computed: {
    staffProfile() {
      return this.broker?.staff_profile || null;
    },
    districtNames() {
      if (!this.staffProfile?.districts_served)
        return "";

      return this.staffProfile.districts_served
        .map((district) => this.getDistrictName(district)?.name)
        .filter(Boolean)
        .join(", ");
    },
  },
  watch: {
    metaData(newMetaData) {
      if (newMetaData && this.staffProfile) {
        if (newMetaData.hasOwnProperty("districtsPicked")) {
          this.staffProfile.districts_served = [
            ...new Set([
              ...this.staffProfile.districts_served,
              ...newMetaData.districtsPicked
            ])
          ];
        }
        if (newMetaData.hasOwnProperty("districtsRemoved")) {
          this.staffProfile.districts_served =
            this.staffProfile.districts_served.filter((d => !newMetaData.districtsRemoved.includes(d)))
        }
        this.staffProfile.districts_served.sort((a, b) => a - b);
      }
    }
  },
  mounted() {
    this.broker = structuredClone(this.payload);
  },
  methods: {
    async saveStaffProfile() {
      if (!this.staffProfile?.id) {
        this.error = "Profil finančníka sa nepodarilo načítať. Skúste popup zatvoriť a otvoriť znova.";
        return;
      }

      this.loading = true;
      this.error = null;
      try {
        await this.$store.dispatch("clientState/patchStaffProfile", {
          profile: this.getStaffProfilePayload()
        })
        this.closePopup();
      } catch (e) {
        this.error = "Nastavenie sa nepodarilo uložiť. Skúste to prosím znova.";
      } finally {
        this.loading = false;
      }
    },
    getStaffProfilePayload() {
      return {
        id: this.staffProfile.id,
        user: this.staffProfile.user,
        is_pooled: Boolean(this.staffProfile.is_pooled),
        districts_served: this.staffProfile.districts_served || [],
      };
    },
    togglePooling() {
      this.staffProfile.is_pooled = !this.staffProfile.is_pooled;
    },
    openBrokerLocalityServed() {
      if (!this.staffProfile)
        return;

      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: null,
        payload: this.staffProfile.districts_served,
        component: "BrokerRegionPickerPopUp",
        rules: ['single'],
      });
    },
    closePopup() {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
    getDistrictName(id) {
      const districts = this.$store.getters["formStore/getFormByType"]("districtChoices");
      for (const district of districts) {
        if (district.id === id) {
          return district;
        }
      }
      return null;
    },
  },
  data: () => ({
    loading: false,
    error: null,
    broker: null,
  })
}
</script>

<style scoped>
.broker-profile-card {
  align-items: flex-start;
  gap: 8px;
}

.broker-profile-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.broker-profile-label {
  color: var(--app-text, #0d1b5e);
  font-weight: 700;
}

.broker-profile-link {
  appearance: none;
  background: transparent;
  border: 0;
  color: var(--app-primary, #2d7fd6);
  cursor: pointer;
  font: inherit;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .02em;
  flex-shrink: 0;
  min-height: 32px;
  padding: 4px 0 4px 12px;
  text-transform: uppercase;
}

.broker-districts {
  color: var(--app-text, #132451);
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.broker-pooling-toggle {
  align-items: center;
  appearance: none;
  background: var(--app-surface, #ffffff);
  box-sizing: border-box;
  border: 0;
  color: var(--app-text, #132451);
  cursor: pointer;
  font: inherit;
  gap: 14px;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
}

.broker-pooling-toggle small {
  color: var(--app-text-muted, #77839f);
  display: block;
  font-size: 12px;
  font-weight: 600;
  margin-top: 3px;
}

.toggle-track {
  background: #dce8f7;
  border: 1px solid #c2d7f3;
  border-radius: 999px;
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  height: 28px;
  padding: 3px;
  transition: background .18s ease, border-color .18s ease;
  width: 48px;
}

.toggle-thumb {
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(13, 27, 94, .18);
  height: 20px;
  transition: transform .18s ease;
  width: 20px;
}

.broker-pooling-toggle.active .toggle-track {
  background: #2d7fd6;
  border-color: var(--app-primary, #2d7fd6);
}

.broker-pooling-toggle.active .toggle-thumb {
  transform: translateX(20px);
}

.error-text {
  color: #b42318;
  background: #fff2f0;
  border: 1px solid #ffd2cc;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
  margin: 0 20px 20px;
  padding: 12px 14px;
}
</style>
